'use client'
import classNames from 'classnames'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import type { FC } from 'react'
import styles from './TopCategoriesSection.module.scss'
import type { TopCountryFilter } from '@/country/types'
import { getConfig } from '@/tools/config'
import { useLocalisation } from '@/tools/i18n/client'
import { slugify } from '@/tools/strings/slugify'
import { Button, ButtonVariants } from '@/tools/ui'

type Props = {
  topCategories: TopCountryFilter[]
}
export const TopCategoriesSection: FC<Props> = ({ topCategories }) => {
  const { appUrl } = getConfig()
  const { country } = useParams()
  const { t, getLanguage } = useLocalisation()
  const language = getLanguage()

  const buildLink = (filter?: TopCountryFilter) =>
    filter
      ? `${appUrl}/${country}/${language}/${slugify(t('seo-landing.breadcrumbs.delivery'))}_glovo/${filter.filterSlug}`
      : `${appUrl}/${country}/${language}/${slugify(t('seo-landing.breadcrumbs.delivery'))}_glovo`

  return (
    topCategories.length > 0 && (
      <section className={styles.wrapper}>
        <h2 className={classNames(styles.title, 'pintxo-typography-title1')}>
          {t('seo-landing.top-filters.title')}
        </h2>
        <div className={styles.container}>
          {topCategories.map((filter) => (
            <Link key={filter.filterName} className={styles.link} href={buildLink(filter)}>
              <Button className={styles.country} variant={ButtonVariants.neutral}>
                {filter.filterName}
              </Button>
            </Link>
          ))}
        </div>
        <Link className={styles.button} href={buildLink()}>
          <Button variant={ButtonVariants.primary}>
            {t('seo-landing.top-filters.all-filters')}
          </Button>
        </Link>
      </section>
    )
  )
}
